var map = {
	"./en-US": [
		"1d58"
	],
	"./en-US.ts": [
		"1d58"
	],
	"./ja-JP": [
		"0d5a",
		"lang-ja-JP"
	],
	"./ja-JP.ts": [
		"0d5a",
		"lang-ja-JP"
	],
	"./ko-KR": [
		"efc8",
		"lang-ko-KR"
	],
	"./ko-KR.ts": [
		"efc8",
		"lang-ko-KR"
	],
	"./th-TH": [
		"6740",
		"lang-th-TH"
	],
	"./th-TH.ts": [
		"6740",
		"lang-th-TH"
	],
	"./zh-CN": [
		"ad1e",
		"lang-zh-CN"
	],
	"./zh-CN.ts": [
		"ad1e",
		"lang-zh-CN"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ad74";
module.exports = webpackAsyncContext;